var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursosOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.5 86.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.4,71.9c4.8,14.7-10.7,13.8-10.7,13.8V28s16.5-2.2,19.9,11c0,0,1.9,8.4-3.6,12.8M38.7,51.6s7,.6,8.6,10.3c2.2,13.7-9.5,16.5-9.5,16.5M33.2,28.4s-2.5,12.2,4.8,12M22.7,28.3S27,9.5,5.6,13.9M26.1,44.6s9.4-1.2,9.4,4.9M46.8,60.7s-11.1-2.6-11,3.6M25.7,74.5h4s3.6-1.2,1.9-7.5M30.1,50.5v5.4s2.5,1.2,2.2,3.4M12.2,71.9c-4.8,14.7,10.7,13.8,10.7,13.8V28s-16.5-2.2-19.8,11c0,0-2,8.4,3.5,12.8M9.9,51.6s-7,.6-8.6,10.3c-2.2,13.7,9.5,16.5,9.5,16.5M15.3,28.4s2.5,12.2-4.8,12M22.4,44.6s-9.4-1.1-9.4,5M1.8,60.7s11.1-2.6,11,3.6M22.8,74.5h-4s-3.6-1.2-1.8-7.5M18.5,51.6v6s-2.5,1.3-2.2,3.8M21.9,17.8s-9.2,4.6-17-4.4c0,0,18.5-11.4,17,4.4ZM26,29S20.7,8.3,46.4,2.5M28,14.7s15.6.4,18.5-12.3c0,0-20.5-7.8-18.5,12.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursosOnline);
export default __webpack_public_path__ + "static/media/cursos-online.c13fcdd665a4bde12cd5f21476a9a296.svg";
export { ForwardRef as ReactComponent };